window.OKJS = window.OKJS || {};
(function (OKJS) {
    OKJS.Validation = {

        //add error validation to an input, triggers on change and formsubmit. Also clears error on "input" if applicable.
        addValidation: function (formElement, inputName, validationName, validationFunction) {
            var input = formElement.querySelector('input[name=' + inputName + ']');
            var inputContainer = input.parentElement.parentElement.parentElement.parentElement;
            var msgId = input.getAttribute('data-error-id-' + validationName);
            var msgElement = document.getElementById(msgId);

            var showError = function () {
                msgElement.classList.remove('hidden');
                inputContainer.classList.add('ng-touched');
                inputContainer.classList.add('ng-invalid');
            };
            var hideError = function () {
                msgElement.classList.add('hidden');
                inputContainer.classList.remove('ng-touched');
                inputContainer.classList.remove('ng-invalid');
            };

            var validateEventHandler = function () {
                if (!validationFunction(input.value)) {
                    showError();
                    return false;
                }
                else {
                    hideError();
                    return true;
                }
            };

            input.addEventListener('change', validateEventHandler); //add validation to change-event (for standard type=text, this occurs on blur)
            input.addEventListener('blur', validateEventHandler); //in case change didn't fire...

            input.addEventListener('input', function () { hideError(); }); //clear error when writing to text inputs

            return validateEventHandler;
        }
    };
}(window.OKJS));
